// extracted by mini-css-extract-plugin
export default {"badge":"tibGz","smallIos":"UpVq2","smallAndroid":"i98_9","buttonSize":"opF88","downloadButton":"SsPE8"};